export const usaId = 6252001
export const ukId = 2635167

// Crown Dependencies
export const isleOfManId = 3042225
export const guernseyId = 3042362
export const jerseyId = 3042142
